import SearchDialog from '@modules/search-dialog'
import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/Auth'

const LayoutLogged: React.FC = () => {
  const { pathname, search } = useLocation()
  const { isLogged, currentUser, renderLoadingLayout, getLoggedUserInfos } =
    useAuth()

  useEffect(() => {
    if (isLogged !== true) return
    getLoggedUserInfos().catch((error) => {
      console.error('Failed to fetch user info:', error)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged])

  if (isLogged === false) {
    // We're not checking !isLogged as isLogged might be undefined during the account fetching on init
    // Ensure redirection to home page if the user is logged
    // If the current route already carries a returnTo (e.g. /auth/2FA?returnTo=/membership/foo),
    // forward that value so the original destination survives the login redirect.
    const existingReturnTo = new URLSearchParams(search).get('returnTo')
    const returnTo = existingReturnTo ?? pathname
    return (
      <Navigate
        to={'/auth/login?returnTo=' + encodeURIComponent(returnTo)}
        replace
      />
    )
  }

  if (currentUser === undefined) {
    // When currentUser is undefined it means the loading is not finished yet
    return renderLoadingLayout()
  }

  return (
    <>
      <SearchDialog.Provider>
        <Outlet />
        <SearchDialog.Modal />
      </SearchDialog.Provider>
    </>
  )
}

export default LayoutLogged
